// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"PostmarkSettingsList_contentComponent__-IPc7","tableContainer":"PostmarkSettingsList_tableContainer__2QXkN","root":"PostmarkSettingsList_root__1CExd"};